<template>
        <div>
                <el-button type="primary"
                        icon="el-icon-plus"
                        size="small"
                        @click="openDialog('add')"
                >新 增</el-button>
                <el-dialog
                        :title="title"
                        width="50%"
                        :bottom="0"
                        top="60px"
                        append-to-body
                        :fullscreen="dialogFull"
                        :close-on-click-modal="false"
                        :visible.sync="dialogVisible"
                        :destroy-on-close="true"
                        :before-close="handleClose"
                        v-loading="loading"
                        class="planManagement-addForm"

                >
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        {{title}}
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFullChange"></i>
                                
                        </div>
                        <el-divider></el-divider>
                </template>
                <div :style="'max-height:'+ dialogBodyHight + 'px;overflow:scroll;'">
                        <avue-form ref="form" id="examinetopic-form" 
                                
                                v-model="form" 
                                v-if="dialogVisible"  
                                :option="option" 
                                >
                        </avue-form>
                </div>
                <template slot="footer">
                        <el-divider></el-divider>
                        <div>
                              <el-button icon="el-icon-circle-plus-outline" @click="submit" size="small" type="primary">{{ title=="新 增"?'保 存':'修 改' }}</el-button>  
                              <el-button icon="el-icon-circle-close" style="margin-right:10px" size="small" @click="handleClose(false)">取 消</el-button>
                        </div>
                </template>
                </el-dialog>
        </div>
</template>
<script>
export default {
        data(){
                
                let validator = (prop,value,callback)=>{
                        console.log(parseInt(value)>parseInt(this.form.score))
                        if(parseInt(value)>parseInt(this.form.score)){
                                callback(false);
                        }else{
                                callback();
                        }
                }
                return{
                        dialogFull:false,
                        viewType:false,
                        dialogBodyHight:0,//弹窗bidy高度
                        addObjectShow:false,//是否展示新增表格表单
                        title:"新增",
                        dialogVisible:false,
                        loading:false,
                        form:{},
                        option:{
                                size:'small',
                                menuPosition:'right',
                                emptyBtn:false,
                                submitIcon:'el-icon-circle-plus-outline',
                                submitText: '保 存',
                                labelWidth:120,
                                submitBtn:false,
                                column:[
                                        {       
                                                label:"标准内容",
                                                prop:'content',
                                                minWidth:200,
                                                slot:true,
                                                span:24,
                                                type:"textarea",
                                                maxlength:200,
                                                showWordLimit:true,
                                                rules: [{
                                                        required: true,
                                                        message: "请输入标准内容",
                                                        trigger: "change"
                                                }]
                                                // overHidden:true,
                                        },
                                        {       
                                                label:"考核要求",
                                                prop:'demand',
                                                minWidth:180,
                                                slot:true,
                                                span:24,
                                                type:"textarea",
                                                maxlength:100,
                                                showWordLimit:true,
                                                rules: [{
                                                        required: true,
                                                        message: "请输入考核要求",
                                                        trigger: "change"
                                                }]
                                                // overHidden:true,
                                        },
                                        {       
                                                label:"分值",
                                                prop:'score',
                                                rules:[
                                                        { required: true, message: '请输入 分值', trigger: 'blur' },
                                                        { pattern:/^(([1-9]{1}[0-9]{0,1})|100)$/g ,message:'请输入1-100整数', trigger: 'blur' },
                                                ],
                                                minWidth:100,
                                        },
                                        {       
                                                label:"基准分值",
                                                prop:'baseScore',
                                                minWidth:100,
                                                rules:[
                                                        { required: true, message: '请输入 基准分值', trigger: 'blur' },
                                                        { pattern:/^(([1-9]{1}[0-9]{0,1})|100)$/g ,message:'请输入1-100整数', trigger: 'cahnge' },
                                                        {
                                                                required:true,
                                                                validator:validator,
                                                                message:'基准分值不能大于分值！',
                                                                trigger:'change'
                                                        },
                                                        
                                                ],
                                        },
                                ]
                        }

                }
        },
        mounted(){
                this.dialogFull = false;
                let bodyHight = document.body.clientHeight;
                this.dialogBodyHight = bodyHight - 320;

        },
        methods:{
                // 提交  根据titil来判断是新增还是编辑
                submit(){
                        this.$refs.form.validate((valid)=>{
                                if(valid){
                                        
                                        if(this.title=="新 增"){
                                                this.$emit('add',this.form);
                                        }else{
                                                this.$emit('update',this.form);
                                        }
                                        this.dialogVisible = false;
                                }
                        })

                },
                
                // 打开弹窗
                openDialog(type,data){
                        
                        if(type=='add'){
                                this.title = "新 增";
                                this.form = {}
                        }else if(type=='view'){
                                this.title = "查 看";
                                this.form = data;
                        }else if(type=='edit'){
                                this.title = "编 辑";
                                this.form = JSON.parse(JSON.stringify(data));
                        }
                        this.dialogVisible = true;
                },
                // 弹窗关闭前
                handleClose(done){
                        let self = this;
                        if(this.viewType){
                                self.dialogVisible = false;
                                return;
                        }
                        this.$confirm('确认关闭?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                        })
                        .then(()=> {
                                
                                self.dialogVisible = false;
                                
                        })
                        .catch(()=> {
                                
                        });
                },
                dialogFullChange(){
                        let bodyHight = document.body.clientHeight;
                        this.dialogFull = !this.dialogFull;
                        if(this.dialogFull){
                                this.dialogBodyHight = bodyHight - 220;
                        }else{
                                this.dialogBodyHight = bodyHight - 320;
                        }
                }
        }

}
</script>